/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../models/AaiChannelItem';
import { AaiCorrelationId } from '../models/AaiCorrelationId';
import { AaiHeaderItem } from '../models/AaiHeaderItem';
import { AaiMessage } from '../models/AaiMessage';
import { AaiMessageBindings } from '../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../models/AaiParameter';
import { AaiServerBindings } from '../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../models/AaiServerBindingsDefinition';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { VisitorAdapter } from '../../core/visitors/VisitorAdapter';

/**
 * Visitor adapter for AsyncAPI visitors.
 * 
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 * @extends VisitorAdapter
 */
export class AaiVisitorAdapter extends VisitorAdapter implements IAaiVisitor {
    /**
     * 
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
    }

    /**
     * 
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
    }

    /**
     * 
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
    }

    /**
     * 
     * @param {Components} node
     */
    public visitComponents(node : Components) {
    }

    /**
     * 
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
    }

    /**
     * 
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
    }

    /**
     * 
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
    }

    /**
     * 
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
    }

    /**
     * 
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
    }

    /**
     * 
     * @param {Server} node
     */
    public visitServer(node : Server) {
    }

    /**
     * 
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
    }

    /**
     * 
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
    }

    /**
     * 
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
    }

    /**
     * 
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
    }

    /**
     * 
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
    }

    /**
     * 
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
    }

    /**
     * 
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
    }

    /**
     * 
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
    }

    /**
     * 
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
    }

    /**
     * 
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
    }

    /**
     * 
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
    }

    /**
     * 
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
    }

    constructor() {
        super();
    }
}
AaiVisitorAdapter["__class"] = "io.apicurio.datamodels.asyncapi.visitors.AaiVisitorAdapter";
AaiVisitorAdapter["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAaiVisitor } from './IAaiVisitor';

